// extracted by mini-css-extract-plugin
module.exports = {"purchase_info":"purchase_purchase_info__iUtIu","btn_1":"purchase_btn_1__wlZpo","btn_2":"purchase_btn_2__THhci"};